export default function isHexColor(value) {
    if (typeof value === 'string' && value.length) {
        return !!value.match(/^([A-Fa-f0-9]{3})?([A-Fa-f0-9]{6})?$/);
    }
    return false;
}
